import React from 'react';
import { Link } from 'react-router-dom';

import '../css/project.scss';

class PrjBottomCmp extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return (
            <React.Fragment>
                <div className="btn_wrap">
                    <Link to="/Work" className="btn action wide">
                        Work List
                    </Link>
                </div>
            </React.Fragment>
        )
    }
}

export default PrjBottomCmp;